/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_TitleInputs */

const en_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Import`)
};

const fr_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Iconik`)
};

const de_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Import`)
};

const it_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione Iconik`)
};

const ru_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Import`)
};

const es_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de Iconik`)
};

const zh_cn2_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik 进口`)
};

const ja_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconikインポート`)
};

const hi_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइकॉनिक आयात`)
};

const pt_pt2_iconik_import_title = /** @type {(inputs: Iconik_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação Icônica`)
};

/**
* | output |
* | --- |
* | "Iconik Import" |
*
* @param {Iconik_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_title = /** @type {((inputs?: Iconik_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_title(inputs)
	if (locale === "de") return de_iconik_import_title(inputs)
	if (locale === "it") return it_iconik_import_title(inputs)
	if (locale === "ru") return ru_iconik_import_title(inputs)
	if (locale === "es") return es_iconik_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_title(inputs)
	if (locale === "ja") return ja_iconik_import_title(inputs)
	if (locale === "hi") return hi_iconik_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_title(inputs)
	return en_iconik_import_title(inputs)
});